import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Input, makeStyles } from '@fluentui/react-components';
import { SearchFilled } from '@fluentui/react-icons';
import { getUrlProtocolAndDomain, hasProtocol } from '@bingads-webui/url-util';

const useStyles = makeStyles({
  subdomainWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    width: '260px',
  },
  divider: {
    marginLeft: '10px',
    marginRight: '10px',
    fontSize: '14px',
  },
});

export const SubdomainInputView = (props) => {
  const {
    i18n, isLoading, defaultDomainUrl, onDomainUrlChange, onSubdomainUrlChange,
  } = props;
  const classes = useStyles();

  const onDomainBlur = useCallback((ev) => {
    const temporaryFinalUrl = ev && ev.target && ev.target.value;
    let newDomainUrl = getUrlProtocolAndDomain(temporaryFinalUrl);

    if (!hasProtocol(newDomainUrl)) {
      newDomainUrl = `https://${newDomainUrl}`;
    }
    onDomainUrlChange(newDomainUrl);
  }, [onDomainUrlChange]);

  const onDomainKeyDown = useCallback((ev) => {
    if (ev.key === 'Enter') {
      onDomainBlur(ev);
    }
  }, [onDomainBlur]);

  const onSubdomainBlur = useCallback((ev) => {
    const newSubdomainUrl = ev && ev.target && ev.target.value;
    onSubdomainUrlChange(newSubdomainUrl);
  }, [onSubdomainUrlChange]);

  const onSubdomainKeyDown = useCallback((ev) => {
    if (ev.key === 'Enter') {
      onSubdomainBlur(ev);
    }
  }, [onSubdomainBlur]);

  return (
    <div className={classes.subdomainWrapper}>
      <Input className={classNames('url-input', classes.input)} defaultValue={defaultDomainUrl} placeholder={i18n.getString(_TL_('Enter your website URL'))} contentBefore={<SearchFilled />} disabled={isLoading} onBlur={onDomainBlur} onKeyDown={onDomainKeyDown} />
      <div className={classes.divider}>
        /
      </div>
      <Input className={classNames('subdomain-input', classes.input)} placeholder={i18n.getString(_TL_('Enter your subdomain'))} disabled={isLoading} onBlur={onSubdomainBlur} onKeyDown={onSubdomainKeyDown} />
    </div>
  );
};

SubdomainInputView.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  defaultDomainUrl: PropTypes.string.isRequired,
  onDomainUrlChange: PropTypes.func.isRequired,
  onSubdomainUrlChange: PropTypes.func.isRequired,
};

